const UNNAMED_CONTACT_PLACEHOLDER = '(Unnamed Contact)';

/**
 * Filter to check whether a name is a blank or not
 * @param {String} name the intended name to be checked on blankness
 * @returns {String} The name if it's valid, otherwise return the placeholder
 */
export default function(name, placeholder = UNNAMED_CONTACT_PLACEHOLDER) {
  if (typeof name !== 'string') return name;

  const trimmedName = `${name}`.trim();

  if (trimmedName) return trimmedName;
  return placeholder;
}
